import React, { Fragment, useState, useEffect } from 'react'
import { Container, Card, Grid, CardContent, Typography } from '@material-ui/core';
import Breadcumb from '../../../components/Breadcumb/Breadcumb';
import CKEditor from "react-ckeditor-component";
import { Faqs, Alerts } from '../../../helpers';
import { useParams } from 'react-router-dom';
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Banner",
        page_path: "/app/profile",
        icon: "",
    }
]
const EditFaq = () => {
    let { id } = useParams();
    const [ques, setQues] = useState('');
    const [ans, setAns] = useState('');
    // const [status, setStatus] = useState(null);

    const handleQuesChange = (e) => {
        setQues(e.target.value);
    }
    const handleChangeAns = (e) => {
        var newContent = e.editor.getData();
        setAns(newContent);
    }
  
    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            ques: ques,
            ans: ans
        }
        let resp = await Faqs.updateFaq(data, id)
        if (resp) {
            if(resp.status){
                Alerts.alertMessage(resp.message, '', 'success')
                setTimeout(function(){
                    window.location.reload();
                 }, 3000);
              }else{
                Alerts.alertMessage(resp.message, '', 'danger')
              }
        }
    }

    const getData = async ()=>{
       let resp = await Faqs.getSingleFaq(id);
       if(resp && resp.status){
        setQues(resp.faq.ques)
        setAns(resp.faq.ans)
        // setStatus(resp.faq.active)
       }

    }
    useEffect(()=>{
       getData();
    },[])
    return (
        <Fragment>
            <Breadcumb items={BreadcrumbData} />
            <div className="page-wrapper mt20">
                <Container >
                    <Card className="card">
                        <CardContent>
                            <Grid container spacing={3}>
                                <Grid item lg={6} sm={6}>
                                    <Typography variant="h5" gutterBottom>
                                        Update Faq
                                    </Typography>
                                    <form onSubmit={handleSubmit}>
                                        <div className='form-group'>
                                            <label>Question</label>
                                            <input type="text" className='form-control' value={ques} onChange={handleQuesChange} />
                                        </div>
                                        <div className='form-group'>
                                            <label>Answer</label>
                                            <CKEditor
                                                activeClass="p10"
                                                content={ans}
                                                events={{
                                                    "afterPaste": handleChangeAns,
                                                    "change": handleChangeAns
                                                }}
                                            />
                                        </div>
                                        {/* <div className='form-group'>
                                            <select className='form-control'>
                                                <option value={true} selected={status === true && 'selected'}>Active</option>
                                                <option value={false} selected={status === false && 'selected'}>Unactive</option>
                                            </select>
                                        </div> */}
                                        <button type="submit" className='btn btn-primary'>Submit</button>
                                    </form>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            </div>
        </Fragment>
    )
}

export default EditFaq